"use client";

import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  Stack,
} from "@mui/material";
import imgPtutor from "../../images/ptutor.png";
import imgPLab from "../../images/plab.png";
import imgPContest from "../../images/pcontest.png";
import imgPCode from "../../images/PyCode.png";
import imgPStudio from "../../images/pstudio.png";
import imgPBuilder from "../../images/pbuilder.png";
import imgPAvatar from "../../images/pavatar.png";
import imgPNote from "../../images/PyNote.png";
import imgPGit from "../../images/PyGit.png";
import imgPSim from "../../images/PySim.png";
import imgPVr from "../../images/PyVR.png";
// More icons for Creating and Sharing sections...

export default function LearningTool() {
  return (
    <Box
      sx={{
        p: 4,
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        flex: 1,
      }}
    >
      {/* Learning Section */}
      <Typography
        variant="h6"
        sx={{
          color: "rgb(15, 105, 185)",
          mb: 2,
        }}
      >
        Learning
      </Typography>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[
          {
            icon: (
              <img src={imgPtutor} alt="PTutor Icon" width="110" height="110" />
            ),
            title: "PTutor",
            link: process.env.PTUTOR_URL,
          },
          {
            icon: (
              <img src={imgPLab} alt="PLab Icon" width="110" height="110" />
            ),
            title: "PLab",
            link: process.env.PLAB_URL,
          },
          {
            icon: (
              <img
                src={imgPContest}
                alt="PContest Icon"
                width="110"
                height="110"
              />
            ),
            title: "PContest",
            link: process.env.URL_CONTEST,
          },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: "100%",
                bgcolor: "rgb(247, 250, 255)",
                border: "1px solid rgb(237, 242, 247)",
                boxShadow: "none",
                borderRadius: 2,
              }}
            >
              <CardContent sx={{ textAlign: "center", p: 3 }}>
                <Box sx={{ mb: 2 }}>{item.icon}</Box>
                <Typography gutterBottom variant="h6">
                  {item.title}
                </Typography>
                {/* <Stack direction="row" spacing={1} justifyContent="center"> */}
                {item.link ? (
                  <a
                    href={item.link}
                    style={{ textDecoration: "none" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      sx={{
                        bgcolor: "rgb(255, 90, 31)",
                        "&:hover": {
                          bgcolor: "rgb(230, 81, 28)",
                        },
                        textTransform: "none",
                      }}
                    >
                      Go
                    </Button>
                  </a>
                ) : (
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      bgcolor: "rgb(255, 90, 31)",
                      "&:hover": {
                        bgcolor: "rgb(230, 81, 28)",
                      },
                      textTransform: "none",
                    }}
                  >
                    Go
                  </Button>
                )}
                {/* </Stack> */}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Creating Section */}
      <Typography
        variant="h6"
        sx={{
          color: "rgb(15, 105, 185)",
          mb: 2,
        }}
      >
        Creating
      </Typography>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[
          {
            link: process.env.PTUTOR_URL,
            icon: (
              <img src={imgPCode} alt="PCode Icon" width="110" height="110" />
            ),
            title: "Pcode",
            links: [
              {
                text: "Leanbot C++ IDE",
                color: "error",
                link: process.env.LBIDE_URL,
              },
              {
                text: "Leanbot Blockly IDE",
                color: "error",
                link: process.env.LBBLOCKLY_URL,
              },
              {
                text: "PMinetest Blockly IDE",
                color: "primary",
                link: process.env.PMINETEST_URL,
              },
            ],
          },
          {
            link: process.env.PTUTOR_URL,
            icon: (
              <img
                src={imgPStudio}
                alt="PStudio Icon"
                width="110"
                height="110"
              />
            ),
            title: "Pstudio",
            links: [
              {
                text: "TwinSpace Studio",
                color: "error",
                link: process.env.DOMAIN_PHUB + "/spoke",
              },
              {
                text: "PMineTest Studio",
                color: "primary",
                link: process.env.PSIM_URL,
              },
            ],
          },
          {
            link: process.env.PTUTOR_URL,
            icon: (
              <img
                src={imgPBuilder}
                alt="PBuilder Icon"
                width="110"
                height="110"
              />
            ),
            title: "PBuilder4AI",
            links: [
              { text: "Leanbot AI Model", color: "error", link: process.env.AI_TRAINING_URL },
              {
                text: "NPC AI model",
                color: "primary",
                link: process.env.AI_TRAINING_URL,
              },
            ],
          },
          {
            link: process.env.PTUTOR_URL,
            icon: (
              <img
                src={imgPAvatar}
                alt="PAvatar Icon"
                width="110"
                height="110"
              />
            ),
            title: "PAvatar",
            links: [
              {
                text: "TwinSpace Avatar Editor",
                color: "error",
                link: process.env.AVATAR_MAKER_URL,
              },
              {
                text: "PMinetest Avatar Editor",
                color: "primary",
                link: process.env.AVATAR_EDITOR_URL,
              },
            ],
          },
          {
            link: process.env.PNOTE_URL,
            icon: (
              <img src={imgPNote} alt="PAvatar Icon" width="110" height="110" />
            ),
            title: "PNote",
            links: [],
          },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
            <Card
              sx={{
                height: "100%",
                bgcolor: "rgb(247, 250, 255)",
                border: "1px solid rgb(237, 242, 247)",
                boxShadow: "none",
                borderRadius: 2,
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  {item.icon && (
                    item.link ? (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Box>{item.icon}</Box>
                      </a>
                    ) : (
                      <Box>{item.icon}</Box>
                    )
                  )}
                  <Typography
                    gutterBottom
                    color="#000"
                    variant="h6"
                    sx={{ textAlign: "center", ml: 2 }}
                  >
                    {item.title}
                  </Typography>
                </Box>
                {item.links.map((link, i) =>
                  link.link ? (
                    <a
                      href={link.link}
                      style={{ textDecoration: "none" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Typography
                        key={i}
                        variant="body2"
                        sx={{
                          fontWeight: 700,
                          fontSize: "1rem",
                          color:
                            link.color === "error"
                              ? "error.main"
                              : "primary.main",
                          cursor: "pointer",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {link.text}
                      </Typography>
                    </a>
                  ) : (
                    <Typography
                      key={i}
                      variant="body2"
                      sx={{
                        fontWeight: 700,
                        fontSize: "1rem",
                        color:
                          link.color === "error"
                            ? "error.main"
                            : "primary.main",
                        cursor: "pointer",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {link.text}
                    </Typography>
                  )
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Sharing Section */}
      <Typography
        variant="h6"
        sx={{
          color: "rgb(15, 105, 185)",
          mb: 2,
        }}
      >
        Sharing
      </Typography>
      <Grid container spacing={3}>
        {[
          {
            icon: (
              <img src={imgPGit} alt="PAvatar Icon" width="110" height="110" />
            ),
            title: "PGit",
            buttons: [
              {
                text: "Leanbot code",
                color: "warning",
                link: process.env.PGIT_URL,
              },
              {
                text: "AI Training Data",
                color: "warning",
                link: process.env.AI_TRAINING_URL,
              },
            ],
          },
          {
            icon: (
              <img src={imgPSim} alt="PAvatar Icon" width="110" height="110" />
            ),
            title: "PSim",
            buttons: [
              { text: "Go", color: "warning", link: process.env.PSIM_URL },
            ],
          },
          {
            icon: (
              <img src={imgPVr} alt="PAvatar Icon" width="110" height="110" />
            ),
            title: "PVr",
            buttons: [
              { text: "Go", color: "warning", link: process.env.PVR_URL },
            ],
          },
          {
            icon: (
              <img src={imgPNote} alt="PAvatar Icon" width="110" height="110" />
            ),
            title: "PHub",
            buttons: [
              {
                text: "Go",
                color: "warning",
                link: process.env.DOMAIN_PHUB + "/signin",
              },
            ],
          },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: "100%",
                bgcolor: "rgb(247, 250, 255)",
                border: "1px solid rgb(237, 242, 247)",
                boxShadow: "none",
                borderRadius: 2,
              }}
            >
              <CardContent sx={{ textAlign: "center", p: 3 }}>
                {item.icon && <Box sx={{ mb: 2 }}>{item.icon}</Box>}
                <Typography
                  gutterBottom
                  variant="h6"
                  sx={{ textAlign: "center", mb: 2 }}
                >
                  {item.title}
                </Typography>
                <Box sx={{ 
                  display: "flex", 
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: 1,
                  justifyContent: "center"
                }}>
                  {item.buttons.map((button, i) => (
                    button.link ? (
                      <a
                        href={button.link}
                        style={{ 
                          textDecoration: "none",
                          flex: "1 1 auto",
                          minWidth: "120px"
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Button
                          fullWidth
                          key={i}
                          variant="contained"
                          sx={{
                            bgcolor: "rgb(255, 90, 31)",
                            "&:hover": {
                              bgcolor: "rgb(230, 81, 28)",
                            },
                            textTransform: "none",
                          }}
                        >
                          {button.text}
                        </Button>
                      </a>
                    ) : (
                      <Button
                        key={i}
                        variant="contained"
                        sx={{
                          flex: "1 1 auto",
                          minWidth: "120px",
                          bgcolor: "rgb(255, 90, 31)",
                          "&:hover": {
                            bgcolor: "rgb(230, 81, 28)",
                          },
                          textTransform: "none",
                        }}
                      >
                        {button.text}
                      </Button>
                    )
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
